import FreepikLogo from "./logos/Freepik.svg?react";
import PexelsLogo from "./logos/Pexels.svg?react";
import ShopifyLogo from "./logos/Shopify.svg?react";
import UnsplashLogo from "./logos/Unsplash.svg?react";
import WebflowLogo from "./logos/Webflow.svg?react";
import WordpressLogo from "./logos/Wordpress.svg?react";
import ZapierLogo from "./logos/Zapier.svg?react";
import WebhookLogo from "./logos/Webhook.svg?react";
import WixLogo from "./logos/Wix.svg?react";
import FramerLogo from "./logos/Framer.svg?react";
import styles from "./LogoIcon.module.scss";
import classNames from "classnames";

export type LogoIconSize =
  | "xxsmall"
  | "xsmall"
  | "small"
  | "medium"
  | "large"
  | "xlarge"
  | "xxlarge";

interface LogoIconProps {
  className?: string;
  size?: LogoIconSize;
}

const getSize = (size: LogoIconSize) => {
  switch (size) {
    case "xxsmall":
      return styles.iconXxsmall;
    case "xsmall":
      return styles.iconXsmall;
    case "small":
      return styles.iconSmall;
    case "medium":
      return styles.iconMedium;
    case "large":
      return styles.iconLarge;
    case "xlarge":
      return styles.iconXlarge;
    case "xxlarge":
      return styles.iconXxlarge;
    default:
      return undefined;
  }
};

export type LogoIconComponentType = React.FunctionComponent<LogoIconProps>;

const withLogoIcon = (
  SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
) => {
  return function IconComponent({ className, size = "small" }: LogoIconProps) {
    return (
      <span className={className}>
        <SvgComponent className={classNames(getSize(size), styles.icon)} />
      </span>
    );
  };
};

export const Freepik = withLogoIcon(FreepikLogo);
export const Pexels = withLogoIcon(PexelsLogo);
export const Unsplash = withLogoIcon(UnsplashLogo);
export const Webflow = withLogoIcon(WebflowLogo);
export const Webhook = withLogoIcon(WebhookLogo);
export const Wordpress = withLogoIcon(WordpressLogo);
export const Zapier = withLogoIcon(ZapierLogo);
export const Shopify = withLogoIcon(ShopifyLogo);
export const Wix = withLogoIcon(WixLogo);
export const Framer = withLogoIcon(FramerLogo);
